import React from 'react';
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tabs,
    Tab,
    Typography,

} from "@material-ui/core";
import useStyles from '../styles/styles';
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter';
import {base16AteliersulphurpoolLight} from 'react-syntax-highlighter/dist/esm/styles/prism';
import {addDays, format} from 'date-fns';

const ExperianPrefillApiPostingInstructions = () => {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [codeTab, setCodeTab] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleCodeTab = (event, newValue) => {
        setCodeTab(newValue);
    };


    const sourceKeyUrl = (new URL(window.location)).searchParams.get("sourceKey");

    const sourceKeySet = sourceKeyUrl ? true : false;

    const sourceKey = sourceKeySet ? sourceKeyUrl : 'XXXXXXXX-XYXX-XXXX-XXXX-XXXXXXXXXXXX';

    function TabPanel(props) {
        const { children, value, value2, index, ...other } = props;

        return (
            <Typography
                component="div"
                role="tabpanel"
                hidden={value !== index}
                id={`wrapped-tabpanel-${index}`}
                aria-labelledby={`wrapped-tab-${index}`}
                {...other}
            >
                {value === index && <Box p={3} pt={1}>{children}</Box>}
            </Typography>
        );
    }

    function TabPanel2(props) {
        const {children, value, index, ...other} = props;

        return (
            <Typography
                component="div"
                role="tabpanel"
                hidden={value !== index}
                id={`wrapped-tabpanel-${index}`}
                aria-labelledby={`wrapped-tab-${index}`}
                {...other}
            >
                {value === index && <Box p={3} pt={1}>{children}</Box>}
            </Typography>
        );
    }

    return (
        <>
            <Typography variant="h2" gutterBottom>
                Prefill Posting Instructions
            </Typography>

            <Paper className={`${classes.paper} ${classes.autoWidth}`}>
                <Table className={`${classes.table} ${classes.marginAuto}`}  size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell variant="head">Endpoint</TableCell>
                            <TableCell variant="head">Address</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>Test</TableCell>
                            <TableCell>https://test-api.acquireinteractive.com/prefill/experian</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Production</TableCell>
                            <TableCell>https://api.acquireinteractive.com/prefill/experian</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>

            <Typography variant="body1">
                <p>
                    The API is authenticated using <a href={"https://www.httpwatch.com/httpgallery/authentication/"}>HTTP Basic Authentication</a> over TLS.
                    Your account manager will provide you with a username and password combination for both the test and prod environments.
                </p>
                <p>
                    Example: username=david, password=strongpassword -- this combination would yield an authorization header as follows: "Authorization: Basic ZGF2aWQ6c3Ryb25ncGFzc3dvcmQ=".
                    Examples of how to include this header can be seen below in the code "Code Samples".
                </p>

                {sourceKeySet ? (
                    <p> The JSON payload will also include a "Source Key" that identified the source of your leads and ensures you are paid for ACCEPTED leads, your source key is "{sourceKey}".</p>
                ) : null}

            </Typography>
            <Paper className={classes.paper}>
                <Table className={classes.table} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell variant="head">Field&nbsp;Name</TableCell>
                            <TableCell variant="head">Data&nbsp;Type</TableCell>
                            <TableCell variant="head">Required</TableCell>
                            <TableCell variant="head">Example</TableCell>
                            <TableCell variant="head">Notes</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>tsid</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>{sourceKey}</TableCell>
                            <TableCell>Required, the traffic source identifier provided by Acquire
                                Interactive</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>experian_transaction_id</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>Yes</TableCell>
                            <TableCell>63565a</TableCell>
                            <TableCell>Represents a set of consumer data attributes for a windowed period of time (currently 30 days),<br/>
                                during which the provided data may be eligible to pre-fill.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>first_name</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>Joesph</TableCell>
                            <TableCell>If present, the customers first name, minimum number of characters accepted is 2,
                                maximum is 64.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>last_name</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>Doe</TableCell>
                            <TableCell>If present, the customers last name, minimum number of characters accepted is 2,
                                maximum is 64.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>primary_email</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>joe.b.doe@acquireinteractive.com</TableCell>
                            <TableCell>If present, the customers valid, well formed email address, maximum length is 128
                                characters.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>phone</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>5123486640</TableCell>
                            <TableCell>
                                If present, send only the 10 significant numbers that make up the phone number.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>date_of_birth</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>1977-06-27</TableCell>
                            <TableCell>If present, the customers date of birth in YYYY-MM-DD format. Date must represent
                                applicants age as 18 or older as of this day.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>ssn</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>200304000</TableCell>
                            <TableCell>If present, send only the 9 significant numbers that make up the customers Social
                                Security Number.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>street_address</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>123 S. Main St.</TableCell>
                            <TableCell>If present, the customers street address, minimum number of characters accepted is
                                6, maximum is 128.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>city</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>Kansas City</TableCell>
                            <TableCell>If present, the customers city, minimum number of characters accepted is 1, maximum
                                is 128.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>state</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>KS<br/>Kansas</TableCell>
                            <TableCell>If present, the customers state, a valid two letter state abbreviation or the full
                                state name</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>zip</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>66102<br/>66102-3225</TableCell>
                            <TableCell>If present, send either the 5 digit ZIP Code or the 10 digit ZIP+4 with the dash in
                                it.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>residence_type</TableCell>
                            <TableCell>Enum</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>OWN</TableCell>
                            <TableCell>
                                If present, does the customer own or rent their residence, one of the following
                                values:<br/>
                                RENT, OWN (case sensitive)</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>residence_length_months</TableCell>
                            <TableCell>Int</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>25</TableCell>
                            <TableCell>If present, number of months the customer has been at their residence</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>military</TableCell>
                            <TableCell>Boolean</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>true<br/>false</TableCell>
                            <TableCell>If present, is the customer active duty military?</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>annual_income</TableCell>
                            <TableCell>Int</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>80000</TableCell>
                            <TableCell>If present, a number representing the customers total annual income.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>state_id_number</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>R500226466455</TableCell>
                            <TableCell>If present, a valid drivers license or state id number. Must be between 1 and 150
                                characters.</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>state_id_issued</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>MO<br/>Missouri</TableCell>
                            <TableCell>If present, the state the state_id_number was issued in, a valid two letter state
                                abbreviation or the full state name</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>title_clear</TableCell>
                            <TableCell>Boolean</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>true<br/>false</TableCell>
                            <TableCell>
                                Pass true if the consumer own a vehicle with a free and clear title
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>title_as_collateral</TableCell>
                            <TableCell>Boolean</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>true<br/>false</TableCell>
                            <TableCell>
                                Pass true if the consumer is interested in using their vehicle title to obtain a larger loan amount
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>vehicle_make</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>Chevy</TableCell>
                            <TableCell>
                                If present, the make of the customers vehicle.
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>vehicle_model</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>Cruze</TableCell>
                            <TableCell>
                                If present, the model of the customers vehicle.
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>vehicle_trim</TableCell>
                            <TableCell>String</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>GT</TableCell>
                            <TableCell>
                                If present, the trim of the customers vehicle.
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>vehicle_year</TableCell>
                            <TableCell>Int</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>2020</TableCell>
                            <TableCell>
                                If present, the year of the customers vehicle.
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>vehicle_mileage</TableCell>
                            <TableCell>Int</TableCell>
                            <TableCell>No</TableCell>
                            <TableCell>100000</TableCell>
                            <TableCell>
                                If present, the number of miles on the customers vehicle.
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>

            <Typography variant="h4" align="left">
                JSON Samples
            </Typography>
            <Paper className={classes.paper}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="Request"/>
                    <Tab label="Response"/>
                    <Tab label="Error"/>
                </Tabs>

                <TabPanel2 value={value} index={0}>
                    <SyntaxHighlighter language="php" style={base16AteliersulphurpoolLight}>
                        {
                            `
{
    "tsid": "` + sourceKey + `",
    "first_name": "Joesph",
    "last_name": "Doe",
    "primary_email": "joe.b.doe@acquireinteractive.com",
    "phone": "5123486640",
    "date_of_birth": "1977-06-27",
    "ssn": "200304000",
    "street_address": "123 S. Main St.",
    "city": "Kansas City",
    "state": "KS",
    "zip": "66102-3225",
    "residence_type": "OWN",
    "residence_length_months": 25,
    "military": false,
    "annual_income": 80000,
    "state_id_number": "R500226466455",
    "state_id_issued": "MO",
    "title_clear": true,
    "title_as_collateral": true,
    "vehicle_make": "Chevy",
    "vehicle_model": "Cruze",
    "vehicle_trim": "GT",
    "vehicle_year": 2020,
    "vehicle_mileage": 100000,
    "experian_transaction_id": "654321abc"
}
                            `}
                    </SyntaxHighlighter>
                </TabPanel2>
                <TabPanel2 value={value} index={1}>
                    <SyntaxHighlighter language="javascript" style={base16AteliersulphurpoolLight}>
                        {
                            `
{
  "success": true,
  "redirect_url": "https://experian.installmentloans.com/click?tsid=${sourceKey}&xaiid=654321abc",
  "validation_errors": {}
}                          `}
                    </SyntaxHighlighter>
                </TabPanel2>
                <TabPanel2 value={value} index={2}>
                    <SyntaxHighlighter language="javascript" style={base16AteliersulphurpoolLight}>
                        {
                            `
{
  "success": false,
  "redirect_url": null,
  "validation_errors": {
        ".experianTransactionId": [
            "is required"
        ],
        ".tsid": [
            "is required"
        ]
    }
}                          `}
                    </SyntaxHighlighter>
                </TabPanel2>
            </Paper>


            <Typography variant="h4" align="left">
                Code Samples
            </Typography>
            <Paper className={classes.paper}>
                <Tabs
                    value={codeTab}
                    onChange={handleCodeTab}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="PHP"/>
                    <Tab label="Node"/>
                    <Tab label="Java"/>
                    <Tab label="C#"/>
                    <Tab label="Curl"/>
                    <Tab label="Python"/>
                </Tabs>

                <TabPanel value={codeTab} index={0}>
                    <SyntaxHighlighter language="php" style={base16AteliersulphurpoolLight}>
                        {
                            `<?php

$curl = curl_init();

curl_setopt_array($curl, array(
    CURLOPT_URL => "https://test-api.acquireinteractive.com/prefill/experian",
    CURLOPT_RETURNTRANSFER => true,
    CURLOPT_ENCODING => "",
    CURLOPT_MAXREDIRS => 10,
    CURLOPT_TIMEOUT => 0,
    CURLOPT_FOLLOWLOCATION => false,
    CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
    CURLOPT_CUSTOMREQUEST => "POST",
    CURLOPT_POSTFIELDS => <<<EOT
    {
      "tsid": "` + sourceKey + `",
      "first_name": "Joesph",
      "last_name": "Doe",
      "primary_email": "joe.b.doe@acquireinteractive.com",
      "phone": "5123486640",
      "date_of_birth": "1977-06-27",
      "ssn": "200304000",
      "street_address": "123 S. Main St.",
      "city": "Kansas City",
      "state": "KS",
      "zip": "66102-3225",
      "residence_type": "OWN",
      "residence_length_months": 25,
      "military": false,
      "annual_income": 80000,
      "state_id_number": "R500226466455",
      "state_id_issued": "MO",
      "title_clear": true,
      "title_as_collateral": true,
      "vehicle_make": "Chevy",
      "vehicle_model": "Cruze",
      "vehicle_trim": "GT",
      "vehicle_year": 2020,
      "vehicle_mileage": 100000,
      "experian_transaction_id": "654321abc"
    }
EOT
    ,CURLOPT_HTTPHEADER => array(
        "Content-Type: application/json",
        "Authorization: Basic dGVzdDp0ZXN0"
    ),
));

$response = curl_exec($curl);
$err = curl_error($curl);

curl_close($curl);

if ($err) {
    echo "cURL Error #:" . $err;
} else {
    echo $response;
} ?>
                        `}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={1}>
                    <SyntaxHighlighter language="javascript" style={base16AteliersulphurpoolLight}>
                        {`
var postData =  \`{
 "tsid": "${sourceKey}",
    "first_name": "Joesph",
    "last_name": "Doe",
    "primary_email": "joe.b.doe@acquireinteractive.com",
    "phone": "5123486640",
    "date_of_birth": "1977-06-27",
    "ssn": "200304000",
    "street_address": "123 S. Main St.",
    "city": "Kansas City",
    "state": "KS",
    "zip": "66102-3225",
    "residence_type": "OWN",
    "residence_length_months": 25,
    "military": false,
    "annual_income": 80000,
    "state_id_number": "R500226466455",
    "state_id_issued": "MO",
    "title_clear": true,
    "title_as_collateral": true,
    "vehicle_make": "Chevy",
    "vehicle_model": "Cruze",
    "vehicle_trim": "GT",
    "vehicle_year": 2020,
    "vehicle_mileage": 100000,
    "experian_transaction_id": "654321abc"
}\`;

var https = require('https');

var options = {
    'host': 'test-api.acquireinteractive.com',
    'method': 'POST',
    'path': '/prefill/experian',
    'headers': {
        'Content-Type': 'application/json',
        'Authorization': 'Basic dGVzdDp0ZXN0',
        'Content-Length': postData.length
    }
};

var req = https.request(options, function (res) {
    var chunks = [];

    res.on("data", function (chunk) {
        chunks.push(chunk);
    });

    res.on("end", function (chunk) {
        var body = Buffer.concat(chunks);
        console.log(body.toString());
    });

    res.on("error", function (error) {
        console.error(error);
    });
});

req.write(postData);

req.end();
                        `}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={2}>
                    <SyntaxHighlighter language="java" style={base16AteliersulphurpoolLight}>
                        {
                            `/*
* To following code is used to create a POST Web request with appropriate information and send it, recieve the response and display the response received.
* In order to execute the code, create a command line app and place the code in the Main() method and run the application to execute the code.
*/ 
try {
    URL a = new URL("https://test-api.acquireinteractive.com/prefill/experian");

    HttpURLConnection urlCon = (HttpURLConnection) a.openConnection();

    urlCon.setRequestMethod("POST");

    urlCon.setRequestProperty("Content-Type", "application/json");

    urlCon.setRequestProperty("Authorization", "Basic dGVzdDp0ZXN0");

    urlCon.setDoOutput(true);

    String json = "{\\"tsid\\": \\"${sourceKey}\\"," +
                    "\\"first_name\\": \\"Joseph\\"," +
                    "\\"last_name\\": \\"Doe\\"," +
                    "\\"primary_email\\": \\"joe.b.doe@acquireinteractive.com\\"," +
                    "\\"phone\\": \\"5123486640\\"," +
                    "\\"date_of_birth\\": \\"1977-06-27\\"," +
                    "\\"ssn\\": \\"200304000\\"," +
                    "\\"street_address\\": \\"123 S. Main St.\\"," +
                    "\\"city\\": \\"Kansas City\\"," +
                    "\\"state\\": \\"KS\\"," +
                    "\\"zip\\": \\"66102-3225\\"," +
                    "\\"residence_type\\": \\"OWN\\"," +
                    "\\"residence_length_months\\": 25," +
                    "\\"military\\": false," +
                    "\\"annual_income\\": 80000," +
                    "\\"state_id_number\\": \\"R500226466455\\"," +
                    "\\"state_id_issued\\": \\"MO\\"," +
                    "\\"title_clear\\": true," +
                    "\\"title_as_collateral\\": true," +
                    "\\vehicle_make\\": \\"Chevy\\"," +
                    "\\vehicle_model\\": \\"Cruze\\"," +
                    "\\vehicle_trim\\": \\"GT\\"," +
                    "\\vehicle_year\\": 2020," +
                    "\\vehicle_mileage\\": 100000," +
                    "\\"experian_transaction_id\\": 654321abc}";

    try (OutputStream os = urlCon.getOutputStream()) {
        byte[] input = json.getBytes("utf-8");
        os.write(input, 0, input.length);
        }

    if (urlCon.getResponseCode() < HttpURLConnection.HTTP_BAD_REQUEST) {
        try (BufferedReader br = new BufferedReader(
            new InputStreamReader(urlCon.getInputStream(), "utf-8"))) {
                StringBuilder response = new StringBuilder();
                String responseLine = null;
                while ((responseLine = br.readLine()) != null) {
                    response.append(responseLine.trim());
                }
                System.out.println(response.toString());
            }
        }
    else {
        try (BufferedReader br = new BufferedReader(
            new InputStreamReader(urlCon.getErrorStream(), "utf-8"))) {
                StringBuilder response = new StringBuilder();
                String responseLine = null;
                while ((responseLine = br.readLine()) != null) {
                    response.append(responseLine.trim());
                }
                System.out.println(response.toString());
            }
        }
    }
catch (MalformedURLException e) {
            e.printStackTrace();
        }
catch (IOException e) {
            e.printStackTrace();
}`}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={3}>
                    <SyntaxHighlighter language="c#" style={base16AteliersulphurpoolLight}>
                        {
                            `/*
* To following code is used to create a POST Web request with appropriate information and send it, recieve the response and display the response received.
* In order to execute the code, create a blank console application and place the code in the Main() method and run the application to execute the code.
*/ 
Console.WriteLine("\\nCreating Request....");
HttpWebRequest httpWebRequest = (HttpWebRequest)WebRequest.Create("https://test-api.acquireinteractive.com/prefill/experian");
httpWebRequest.ContentType = "application/json";
httpWebRequest.Method = "POST";
httpWebRequest.Headers.Add("Authorization", "Basic dGVzdDp0ZXN0");

using (var streamWriter = new StreamWriter(httpWebRequest.GetRequestStream()))
{
    string json = "{\\"tsid\\": \\"${sourceKey}\\"," +
                    "\\"first_name\\": \\"Joseph\\"," +
                    "\\"last_name\\": \\"Doe\\"," +
                    "\\"primary_email\\": \\"joe.b.doe@acquireinteractive.com\\"," +
                    "\\"phone\\": \\"5123486640\\"," +
                    "\\"date_of_birth\\": \\"1977-06-27\\"," +
                    "\\"ssn\\": \\"200304000\\"," +
                    "\\"street_address\\": \\"123 S. Main St.\\"," +
                    "\\"city\\": \\"Kansas City\\"," +
                    "\\"state\\": \\"KS\\"," +
                    "\\"zip\\": \\"66102-3225\\"," +
                    "\\"residence_type\\": \\"OWN\\"," +
                    "\\"residence_length_months\\": 25," +
                    "\\"military\\": false," +
                    "\\"annual_income\\": 80000," +
                    "\\"state_id_number\\": \\"R500226466455\\"," +
                    "\\"state_id_issued\\": \\"MO\\"," +
                    "\\"title_clear\\": true," +
                    "\\"title_as_collateral\\": true," +
                    "\\"vehicle_make\\": \\"Chevy\\"," +
                    "\\"vehicle_model\\": \\"Cruze\\"," +
                    "\\"vehicle_trim\\": \\"GT\\"," +
                    "\\"vehicle_year\\": 2020," +
                    "\\"vehicle_mileage\\": 100000," +
                    "\\"experian_transaction_id\\": \\"654321abc\\"}";
                                  
    streamWriter.Write(json);

}
Console.WriteLine("\\nRequest Created....");
Console.WriteLine("\\nSeding Request....");

try
{
    var httpResponse = (HttpWebResponse)httpWebRequest.GetResponse();

    using (var streamReader = new StreamReader(httpResponse.GetResponseStream()))
    {
        var result = streamReader.ReadToEnd();
        Console.WriteLine("\\nResponse received: " + result);
        Console.ReadLine();
    }
}
catch (WebException e)
{
    using (WebResponse response = e.Response)
    {
        using (Stream data = response.GetResponseStream())
        {
            StreamReader sr = new StreamReader(data);
            Console.WriteLine("\\nErred Response received: " + sr.ReadToEnd());
            Console.ReadLine();
        }
    }
}
   `}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={4}>
                    <SyntaxHighlighter language="bash" style={base16AteliersulphurpoolLight}>
                        {`
curl --location --request POST "https://test-api.acquireinteractive.com/prefill/experian" \\
    --header "Content-Type: application/json" \\
    --header "Authorization: Basic dGVzdDp0ZXN0" \\
    --data "{
      \\"tsid\\": \\"` + sourceKey + `\\",
      \\"first_name\\": \\"Joesph\\",
      \\"last_name\\": \\"Doe\\",
      \\"primary_email\\": \\"joe.b.doe@acquireinteractive.com\\",
      \\"phone\\": \\"5123486640\\",
      \\"date_of_birth\\": \\"1977-06-27\\",
      \\"ssn\\": \\"200304000\\",
      \\"street_address\\": \\"123 S. Main St.\\",
      \\"city\\": \\"Kansas City\\",
      \\"state\\": \\"KS\\",
      \\"zip\\": \\"66102-3225\\",
      \\"residence_type\\": \\"OWN\\",
      \\"residence_length_months\\": 25,
      \\"military\\": false,
      \\"annual_income\\": 80000,
      \\"state_id_number\\": \\"R500226466455\\",
      \\"state_id_issued\\": \\"MO\\",
      \\"title_clear\\": true,"
      \\"title_as_collateral\\": true, 
      \\"vehicle_make\\": \\"Chevy\\", 
      \\"vehicle_model\\": \\"Cruze\\",
      \\"vehicle_trim\\": \\"GT\\", 
      \\"vehicle_year\\": 2020,
      \\"vehicle_mileage\\": 100000, 
      \\"experian_transaction_id\\": \\"654321abc\\"
}"
                            `}
                    </SyntaxHighlighter>
                </TabPanel>
                <TabPanel value={codeTab} index={5}>
                    <SyntaxHighlighter language="python" style={base16AteliersulphurpoolLight}>
                        {`
import requests

url = "https://test-api.acquireinteractive.com/prefill/experian"
data = {'tsid': '${sourceKey}',
        'first_name': 'Joseph',
        'last_name': 'Doe',
        'primary_email': 'joe.b.doe@acquireinteractive.com',
        'phone': '5123486640',
        'date_of_birth': '1977-06-27',
        'ssn': '200304000',
        'street_address': '123 S. Main St.',
        'city': 'Kansas City',
        'state': 'KS',
        'zip': '66102-3225',
        'residence_type': 'OWN',
        'residence_length_months': 25,
        'military': False,
        'annual_income': 80000,
        'state_id_number': 'R500226466455',
        'state_id_issued': 'MO',
        "title_clear": True,
        "title_as_collateral": True,
        "vehicle_make": "Chevy",
        "vehicle_model": "Cruze",
        "vehicle_trim": "GT",
        "vehicle_year": 2020,
        "vehicle_mileage": 100000,
        "experian_transaction_id": "654321abc"}

headers = {'Content-Type': 'application/json', 'Authorization': 'Basic dGVzdDp0ZXN0'}
try:
    r = requests.post(url, data=data, headers=headers)
    r.raise_for_status()
    print(r.text)
except requests.exceptions.HTTPError as errh:
    print ("Http Error:",errh)
except requests.exceptions.ConnectionError as errc:
    print ("Error Connecting:",errc)
except requests.exceptions.Timeout as errt:
    print ("Timeout Error:",errt)
except requests.exceptions.RequestException as err:
    print ("Oops: Something Else",err)
                        `}
                    </SyntaxHighlighter>
                </TabPanel>
            </Paper>

        </>
    );
};

export default ExperianPrefillApiPostingInstructions
